/* eslint-disable */
/* Generated code by DoneDone's Code Generator */
/* Originally written by Pixelmatters team */
import axios, {
  AxiosInstance,
  AxiosResponse,
  AxiosRequestConfig,
  AxiosError,
} from 'axios'
import getBrowser from '@/plugins/device-info/features/browser'

export interface IParams {
  [key: string]: any
}
export interface IOptions {
  url: string
  params?: IParams
  data?: object
}

export class RequestHandler {
  private axiosClient: AxiosInstance

  constructor(enableRequestInterceptors: boolean = true) {
    this.axiosClient = axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `AUTH`,
        'X-Frame-Options': 'SAMEORIGIN',
      },
      withCredentials: true,
    })

    if (enableRequestInterceptors) {
      this.axiosClient.interceptors.request.use(
        this.interceptorRequestSuccess,
        this.interceptorRequestError,
      )
    }
    this.axiosClient.interceptors.response.use(
      this.interceptorResponseSuccess,
      this.interceptorResponseError,
    )
  }

  /**
   * Interceptor for error requests
   *
   * @param config AxiosRequestConfig
   */
  private interceptorRequestSuccess(
    config: AxiosRequestConfig,
  ): AxiosRequestConfig {
    return config
  }

  /**
   * Interceptor for error requests
   *
   * @param error AxiosError
   */
  private interceptorRequestError(error: AxiosError): Promise<AxiosResponse> {
    if (process.env.NODE_ENV === 'development') {
      console.error('[HTTP] request interceptor: ', error)
    }
    return Promise.reject(error.response)
  }

  /**
   * Interceptor for success responses
   *
   * @param response
   */
  private interceptorResponseSuccess(response: AxiosResponse): AxiosResponse {
    if (response === undefined) {
      if (process.env.NODE_ENV === 'development') {
        console.error('[HTTP] response interceptor: empty response')
      }
      throw new Error()
    }
    return response
  }

  /**
   * Interceptor for error response
   *
   * @param error AxiosError
   */
  private interceptorResponseError(error: AxiosError): Promise<AxiosResponse> {
    if (process.env.NODE_ENV === 'development') {
      console.error('[HTTP] response interceptor: ', error)
    }

    // If app can't reach server we simulate a 503 http status code
    if (!error.response) {
      error.response = {
        status: 503,
        config: {},
        data: {},
        headers: [],
        request: {},
        statusText: '',
      }
    }

    return Promise.reject(error.response)
  }

  // Replaces [[ACCOUNT_ID]] in URL to account ID based on current path
  private replaceAccountIDForUrl(url: string): string {
    const pathArray = window.location.pathname.split('/')
    if (pathArray.length > 1) {
      const accountID = pathArray[1]
      if (accountID.match(/^-{0,1}\d+$/)) {
        return url.replace('[[ACCOUNT_ID]]', accountID)
      }
    }
    return url
  }

  /**
   * Method call GET request
   *
   * @param url: path url
   * @param params: params pass to GET ex: http://url?id=123
   * @returns data based in the Interface
   */
  protected async get<T>(options: IOptions): Promise<AxiosResponse['data']> {
    const timestamp = Date.now()
    const browser = getBrowser()
    const url = this.replaceAccountIDForUrl(options.url)
    const axiosResponse = await this.axiosClient.request<T>({
      method: 'get',
      url:
        browser.name === 'Internet Explorer'
          ? url+ `?c=${timestamp}`
          : url,
      params: options.params,
    })
    return axiosResponse ? axiosResponse.data : null
  }

  /**
   * @description: Method call DELETE request
   * @param url: path url
   * @param params: params pass to GET ex: http://url?id=123
   * @returns data based in the Interface
   */
  protected async delete<T>(options: IOptions): Promise<AxiosResponse['data']> {
    const url = this.replaceAccountIDForUrl(options.url)
    const axiosResponse = await this.axiosClient.request<T>({
      method: 'delete',
      url: url,
      params: options.params,
    })
    return axiosResponse ? axiosResponse.data : null
  }

  /**
   * @description: Method call POST request
   * @param url: path url
   * @param data: data send to request http
   * @returns Axiosresponse
   */
  protected async post<T>(options: IOptions): Promise<AxiosResponse['data']> {
    const url = this.replaceAccountIDForUrl(options.url)
    const axiosResponse = await this.axiosClient.request<T>({
      method: 'post',
      url: url,
      data: options.data,
    })
    return axiosResponse ? axiosResponse.data : null
  }

  /**
   * @description: Method call PUT request
   * @param url: path url
   * @param data: data send to request http
   * @returns Axiosresponse
   */
  protected async put<T>(options: IOptions): Promise<AxiosResponse['data']> {
    const url = this.replaceAccountIDForUrl(options.url)
    const axiosResponse = await this.axiosClient.request<T>({
      method: 'put',
      url: url,
      data: options.data,
    })
    return axiosResponse ? axiosResponse.data : null
  }

  /**
   * @description: Method call PATH request
   * @param url: path url
   * @param data: data send to request http
   * @returns Axiosresponse
   */
  protected async patch<T>(options: IOptions): Promise<AxiosResponse['data']> {
    const url = this.replaceAccountIDForUrl(options.url)
    const axiosResponse = await this.axiosClient.request<T>({
      method: 'patch',
      url: url,
      data: options.data,
    })
    return axiosResponse ? axiosResponse.data : null
  }
}
